import {useEffect, useState} from 'react';
import close from './assets/close.svg';
import notifyOpen from './assets/notifyOpen.svg';
import notifyClose from './assets/notifyClose.svg';
import './index.scss';

interface IProps {
    text?: string;
    onDestory?: () => void;
    mode: 'preview' | 'edit';
    onChange?: (value: boolean) => void;
    value: boolean;
}
interface ISwitchProps {
    open: boolean;
    handleSwitchClick: (e:any) => void;
}

const Switch = (props: ISwitchProps) => {
    const {open, handleSwitchClick} = props;
    const openBg = 'linear-gradient(108.79deg, #62AFFF 837.47%, #3377FF 9162.53%)';
    const closeBg = 'linear-gradient(108.79deg, #D7DBE2 919.79%, #C8CBD1 9162.53%)';
    const style = {
        background: open ? openBg : closeBg,
    };
    const dotStyle = {
        transform: open ? 'translateX(14px)' : 'translateX(0)',
        transition: 'transform 0.3s ease-in-out',
    };
    return <div className="notification-config-switch-wrapper" style={style} onClick={handleSwitchClick}>
        <div className="notification-config-switch-dot" style={dotStyle} />
    </div>;
};

const NotificationConfig = (props: IProps) => {
    const {text, onDestory, mode, onChange, value} = props;
    const [configState, setConfigState] = useState(value);
    const [show, setShow] = useState(true);

    useEffect(() => {
        setConfigState(value);
    }, [value]);
    const wrapperStyle = {
        justifyContent: mode === 'preview' ? 'space-between' : 'center',
    };
    const handleClose = () => {
        setShow(false);
        if (onDestory) {
            onDestory();
        }
    };
    const handleSwitchClick = (e:any) => {
        if (!e.isTrusted) {
            return;
        }
        setConfigState(!configState);
        if (onChange) {
            onChange(!configState);
        }
    };

    if (!show) {
        return null;
    }
    return <div className="notification-config-wrapper" style={wrapperStyle}>
        {mode === 'preview' && <div className="notification-config-top"></div>}
        <div className="notification-config-content">
            <div className="notification-config-content-title">
                <div>通知设置</div>
                <img className="notification-config-content-title-img" src={close} onClick={handleClose} />
            </div>
            <div className="notification-config-content-config">
                <div className="notification-config-content-config-title">
                    <div className="notification-config-content-config-title-text">如流「知识通知」服务号接收该随心搭通知</div>
                    <Switch open={configState} handleSwitchClick={handleSwitchClick} />
                </div>
                {text && <div className="notification-config-content-config-text">{text}</div>}
            </div>
            <div className="notification-config-content-bottom">
                <img src={configState ? notifyOpen : notifyClose} />
                <div className="notification-config-content-bottom-text">
                    通知已{configState ? '开启' : '关闭'}
                    {mode === 'edit' && <span>，可在随心搭-悬浮菜单中设置</span>}
                </div>
            </div>
        </div>
        {mode === 'preview' && <div className="notification-config-bottom"></div>}
    </div>;
};

export default NotificationConfig;
